module.exports = __webpack_public_path__ + "img/course_003.07c3fa4.png";